module.exports = __webpack_public_path__ + "img/TelegramLogo.fe9cdd4c.png";